import React, { useEffect, useState } from 'react';
import cn from 'classnames';

import CancellationItem from '../CancellationItem';
import Button from '../../../common/ui/Button';
import Modal from '../../../common/ui/Modal';
import Checkbox from '../../../form/Checkbox';
import Link from '../../../common/ui/Link';
import ArrowIcon from '../../../../assets/icons/common/ArrowIcon';
import BeforeYouGoModal from '../BeforeYouGoModal';

import styles from './styles.module.scss';

const cancellationPopupFields = [
  {
    type: 'connection_issue',
    label: 'Connection Issue',
    title: 'What’s wrong with the connection?',
    rechargeBaseReason: 'Connection Issue',
    inputType: 'radio',
    innerQuestions: [
      {
        label: 'Slow Speed',
        wing_type: 'connection_issue__slow_speed',
      },
      {
        label: 'No Coverage',
        wing_type: 'connection_issue__no_coverage',
      },
      {
        label: 'Connection Status is Offline',
        wing_type: 'connection_issue__no_service',
      },
    ],
  },
  {
    type: 'defective',
    label: 'Defective Device / Issue',
    title: 'What’s wrong with the device?',
    rechargeBaseReason: 'Defective',
    inputType: 'radio',
    innerQuestions: [
      {
        label: 'Overheating / Swollen Battery',
        wing_type: 'defective__overheating_or_swollen_battery',
      },
      {
        label: 'Not Charging',
        wing_type: 'defective__not_charging',
      },
      {
        label: 'Keeps on Rebooting',
        wing_type: 'defective__keeps_on_rebooting',
      },
      {
        label: 'Not Turning Off',
        wing_type: 'defective__not_turning_off',
      },
      {
        label: 'Unable to Support Other Devices',
        wing_type: 'defective__unable_to_support_other_devices',
      },
    ],
  },
  {
    type: 'switching_to_other_provider',
    label: 'Switching to Another Provider',
    rechargeBaseReason: 'Switching to Other Provider',
    title: 'Why are you switching?',
    inputType: 'radio',
    innerQuestions: [
      {
        label: 'Better Offer',
        wing_type: 'switching_to_other_provider__better_offer',
      },
      {
        label: 'Better Coverage',
        wing_type: 'switching_to_other_provider__better_coverage',
      },
      {
        label: 'Something Else',
        wing_type: 'switching_to_other_provider__unable_to_identify_reason',
      },
    ],
  },
  {
    type: 'cannot_afford_the_product',
    label: 'Cannot Afford',
    wing_type: 'cannot_afford_the_product',
    rechargeBaseReason: 'Cannot Afford the Product',
    inputType: 'radio',
    innerQuestions: [],
  },
  {
    type: 'relocated__service_or_product_not_needed',
    label: 'Don’t need the service anymore',
    rechargeBaseReason: 'Relocated / Service or Product Not Needed',
    wing_type: 'relocated__service_or_product_not_needed',
    inputType: 'radio',
    innerQuestions: [],
  },
  {
    type: 'customer_service',
    label: 'Customer Service',
    title: 'What’s wrong with the customer service?',
    rechargeBaseReason: 'Customer Service',
    inputType: 'radio',
    innerQuestions: [
      {
        label: 'Wait Time',
        wing_type: 'customer_service__wait_time',
      },
      {
        label: 'Response Time',
        wing_type: 'customer_service__response_time',
      },
      {
        label: 'Rudeness',
        wing_type: 'customer_service__rudeness',
      },
      {
        label: 'No Voice Option',
        wing_type: 'customer_service__no_voice_option',
      },
      {
        label: 'Unfulfilled Promise',
        wing_type: 'customer_service__unfulfilled_promise',
      },
    ],
  },
];

const CancellationModal = ({ submitHandler, isOpen, close, isLoading }) => {
  const [mainReason, setMainReason] = useState(null);
  const [policyChecked, setPolicyChecked] = useState(false);
  const [additionalReason, setAdditionalReason] = useState(null);
  const [additionalReasonsList, setAdditionalReasonsList] = useState(null);
  const [isBeforeYouGoModalOpen, setIsBeforeYouGoModalOpen] = useState(false);
  const [beferoYouGoDescription, setBeferoYouGoDescription] = useState('');
  const isDisabled = getDisableStatus();
  const title = additionalReasonsList?.innerQuestions?.length
    ? additionalReasonsList.title
    : 'We’re sorry to see you go :(';
  const handleMainInputChange = (event) => {
    setMainReason(event.target.value);
  };

  const togglePolicyChecked = () => {
    setPolicyChecked(!policyChecked);
  };

  const handleAdditionalInputChange = (event) => {
    setAdditionalReason(event.target.value);
  };

  const handleSubmit = async () => {
    const mainReasonItem = cancellationPopupFields.find(
      (cancellationPopupField) => {
        return cancellationPopupField.type === mainReason;
      },
    );
    const additionalReasonItem = mainReasonItem?.innerQuestions?.find(
      (innerQuestion) => {
        return innerQuestion.wing_type === additionalReason;
      },
    );

    if (additionalReasonItem) {
      await submitHandler({
        rechargeReason: `${mainReasonItem.label} / ${additionalReasonItem.label}`,
        wingReason: additionalReasonItem.wing_type,
      });
    } else {
      await submitHandler({
        rechargeReason: `${mainReasonItem.label}`,
        wingReason: mainReasonItem.wing_type,
      });
    }
    setIsBeforeYouGoModalOpen(false);
    resetModal();
  };

  const handleSubmitBaseModal = () => {
    console.log(mainReason);
    if (mainReason === 'connection_issue') {
      setBeferoYouGoDescription(
        'We can help fix your connection issue, often quickly',
      );
      close();
      setIsBeforeYouGoModalOpen(true);
    } else if (mainReason === 'defective') {
      setBeferoYouGoDescription(
        'We can help fix your device issue, often quickly',
      );
      close();
      setIsBeforeYouGoModalOpen(true);
    } else {
      handleSubmit();
    }
  };
  const resetModal = () => {
    setMainReason(null);
    setPolicyChecked(false);
    setAdditionalReason(null);
    setAdditionalReasonsList(null);
  };

  const handleClose = () => {
    close();
    resetModal();
  };

  const resetAdditionalQuestion = () => {
    setAdditionalReason(null);
    setAdditionalReasonsList(null);
    setMainReason(null);
  };

  useEffect(() => {
    setAdditionalReasonsList(
      cancellationPopupFields.find((cancellationPopupField) => {
        return (
          cancellationPopupField.type === mainReason &&
          cancellationPopupField.innerQuestions.length
        );
      }),
    );
    setAdditionalReason(null);
  }, [mainReason]);

  return (
    <>
      <Modal
        preventClosing={true}
        isOpen={isOpen}
        onClose={handleClose}
        className={styles.baseModal}
      >
        <div
          className={cn(styles.headerWrapper, {
            [styles.activeAdditionalList]: additionalReasonsList,
          })}
        >
          {additionalReasonsList && (
            <button
              className={styles.backButton}
              onClick={resetAdditionalQuestion}
            >
              <ArrowIcon />
            </button>
          )}
          <h3 className={cn('h3', styles.title)}>{title}</h3>
        </div>
        {!additionalReasonsList && (
          <p className={styles.description}>Why would you like to cancel?</p>
        )}
        {!additionalReasonsList && (
          <ul className={styles.mainQuestionsList}>
            {cancellationPopupFields.map((item, index) => (
              <li key={index}>
                <CancellationItem
                  onChange={handleMainInputChange}
                  name="question"
                  label={item.label}
                  value={item.type}
                ></CancellationItem>
              </li>
            ))}
          </ul>
        )}

        {additionalReasonsList && (
          <ul className={styles.mainQuestionsList}>
            {additionalReasonsList.innerQuestions.map((item, index) => (
              <li key={index}>
                <CancellationItem
                  onChange={handleAdditionalInputChange}
                  name="additional-question"
                  checked={additionalReason === item.wing_type}
                  label={item.label}
                  value={item.wing_type}
                ></CancellationItem>
              </li>
            ))}
          </ul>
        )}
        <div className={styles.footer}>
          <div className={styles.footerPolicy}>
            <Checkbox
              value={policyChecked}
              onChange={togglePolicyChecked}
              label={null}
            />
            <p>
              By clicking here I have read and fully understand the{' '}
              <Link
                to="https://homefi.info/pages/return-policy"
                target="_blank"
                colorType={'orange'}
              >
                cancellation policy
              </Link>{' '}
              and my options. I understand that by pressing the “Cancel
              Subscription” button my service will deactivate immediately and I
              will have 7 days to initiate my device return to{' '}
              <Link
                to="https://homefi.info/pages/return-policy"
                target="_blank"
                colorType={'orange'}
              >
                avoid fees
              </Link>
              .
            </p>
          </div>
          <Button
            disabled={isDisabled}
            onClick={handleSubmitBaseModal}
            isLoading={isLoading}
          >
            Cancel Subscription
          </Button>
        </div>
      </Modal>
      <BeforeYouGoModal
        isOpen={isBeforeYouGoModalOpen}
        description={beferoYouGoDescription}
        onSubmit={handleSubmit}
        onClose={() => setIsBeforeYouGoModalOpen(false)}
        isBtnDisabled={isDisabled}
        isBtnLoading={isLoading}
      />
    </>
  );

  function getDisableStatus() {
    if (mainReason && policyChecked) {
      if (additionalReasonsList?.innerQuestions?.length) {
        return !additionalReason;
      } else {
        return false;
      }
    } else {
      return true;
    }
  }
};
export default CancellationModal;
